<template>
    <client-page class="app--main">
        <!-- S:: 메인 비주얼 -->
        <v-container class="container--large">
            <main-visual v-if="$vuetify.breakpoint.smAndUp" code="main-pc"></main-visual>
            <main-visual v-else code="main-mobile"></main-visual>
        </v-container>
        <!-- E:: 메인 비주얼 -->

        <main-section class="main-section--recruitment">
            <main-banner code="main-side-1-pc" pc vertical class="main-banner--vertical" />

            <main-recruitment-list title="최근 게시된 채용공고" v-bind="recruitmentListProps.recent" class="mb-40 mb-lg-80" />

            <main-banner code="main-sub-1-pc" pc />
            <main-banner code="main-sub-1-mobile" mobile />

            <main-recruitment-list title="인기 채용공고" v-bind="recruitmentListProps.popular" class="my-40 my-lg-80" />

            <main-banner code="main-sub-2-pc" pc />
            <main-banner code="main-sub-2-mobile" mobile />

            <main-recruitment-list title="마감 임박 채용공고" v-bind="recruitmentListProps.closing" class="mt-40 mt-lg-80" />
        </main-section>

        <main-section title="프로필을 등록하고 시작해보세요" class="grey-f7">
            <v-row justify="center" class="my-n14 ma-xl-n54 text-center">
                <v-col v-for="item in visions" :key="item.title" cols="12" sm="6" md="4" class="py-14 pa-xl-54">
                    <v-img :src="item.image" class="w-100 mb-20 mb-lg-40" />
                    <h4 class="font-size-20 font-size-lg-24 mb-8 mb-lg-16">
                        {{ item.title }}
                    </h4>
                    <p v-html="item.sc" class="page-text--lg grey--text word-keep-all"></p>
                </v-col>
            </v-row>
            <div class="mt-40 mt-lg-80">
                <v-row justify="center" class="row-cols-md-5">
                    <v-col v-for="item in partners" :key="item.logo" cols="6" sm="4">
                        <v-img :src="item.logo" max-width="256" contain class="w-100 mx-auto" />
                    </v-col>
                </v-row>
            </div>
        </main-section>

        <section class="main-section--link">
            <v-container class="container--large">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-btn to="/center/faqs" tile block color="primary" class="v-btn--main-link v-btn--main-link--left">
                            <i class="icon icon-faq"></i>
                            <span class="d-inline-block ml-4 ml-lg-8 mr-12 mr-lg-40">FAQ</span>
                            <i class="icon icon-right-arrow-shadow"></i>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="border-start white">
                        <v-btn href="/dashboard/queries" tile block color="primary" class="v-btn--main-link v-btn--main-link--right">
                            <i class="icon icon-question"></i>
                            <span class="d-inline-block ml-4 ml-lg-8 mr-12 mr-lg-40">1:1 문의</span>
                            <i class="icon icon-right-arrow-shadow"></i>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainBanner from "@/components/client/main/main-banner.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainRecruitmentList from "@/components/client/main/main-recruitment-list.vue";
import { RECRUITMENT_LIST_SORTS, RECRUITMENT_STATES } from "@/assets/variables";

const itemsLength = 4;

export default {
    components: {
        ClientPage,
        MainVisual,
        MainBanner,
        PopupLayer,
        MainSection,
        MainRecruitmentList,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        visions: [
            {
                title: "Common Application",
                sc: "매번 기업 또는 행사때마다 작성해야하는 지원서 Word, Hwp, Online-Form 등등 종류도 각양각색! 이제 마이스펙 하나로 정리해드리겠습니다!",
                image: "/images/main/s2-img1.jpg",
            },
            {
                title: "Career Management",
                sc: "정규직, 계약직, 단기 행사 운영요원 등등 <br class='d-none d-xl-block'> 많아도 너무 많은 내 경력들! <br class='d-none d-xl-block'> 여러분의 소중한 경력! 마이스펙이 관리해드립니다!",
                image: "/images/main/s2-img2.jpg",
            },
            {
                title: "Cercertificate of activity",
                sc: "마이스펙을 통해 진행하셨던 <br class='d-none d-xl-block'> 행사 및 경력들은 채용관리자의 간단한 승인으로 손쉽게 증명서 발급이 가능합니다",
                image: "/images/main/s2-img3.jpg",
            },
        ],

        partners: [{ logo: "/images/main/logo1.png" }, { logo: "/images/main/logo2.png" }, { logo: "/images/main/logo3.png" }, { logo: "/images/main/logo4.png" }, { logo: "/images/main/logo5.png" }],

        recruitmentListProps: {
            recent: {
                route: {
                    path: "/recruitments",
                    query: { sort: RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.value },
                },
                headers: {
                    limit: itemsLength * 2,
                    sort: JSON.stringify(RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.sort),
                },
                params: {
                    state: [RECRUITMENT_STATES.ON_GOING.value],
                    "application.endsAt": [ null, { $gte: Date.now() }]
                },
            },
            popular: {
                route: {
                    path: "/recruitments",
                    query: { sort: RECRUITMENT_LIST_SORTS.HIT_COUNTS_DESC.value },
                },
                headers: {
                    limit: itemsLength * 2,
                    sort: JSON.stringify(RECRUITMENT_LIST_SORTS.HIT_COUNTS_DESC.sort),
                },
                params: {
                    // state: [RECRUITMENT_STATES.FINISHED.value, RECRUITMENT_STATES.ON_GOING.value],
                    state: [RECRUITMENT_STATES.ON_GOING.value],
                    "application.endsAt": [ null, { $gte: Date.now() }]
                },
            },
            closing: {
                route: {
                    path: "/recruitments",
                    query: { sort: RECRUITMENT_LIST_SORTS.APPLICATION_ASC.value },
                },
                headers: {
                    limit: itemsLength * 2,
                    sort: JSON.stringify(RECRUITMENT_LIST_SORTS.APPLICATION_ASC.sort),
                },
                params: {
                    ...RECRUITMENT_LIST_SORTS.APPLICATION_ASC.params(),
                    state: [RECRUITMENT_STATES.ON_GOING.value],
                },
            },
        },
    }),
};
</script>

<style lang="scss" scoped>
.main-section--link {
    .container.container--large {
        max-width: var(--container-lg);
        padding: 0;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
    padding: 0;
    height: 120px;
    font-size: 2.6rem;
    font-weight: 700;
    overflow: visible;
    &::after,
    &::before {
        content: "";
        position: absolute;
        display: block;
        width: 50vw;
        height: 100%;
        top: 0;
    }
    &::after {
        background-color: var(--v-primary-base);
        opacity: 1;
        z-index: 0;
    }
    &::before {
        z-index: 2;
    }
    .v-btn__content {
        z-index: 1;
    }
    .icon-right-arrow-shadow {
        position: relative;
        left: 0;
        transition: 0.15s ease-out;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link.v-btn--main-link--left {
    &::after,
    &::before {
        left: unset;
        right: 0;
    }
}
::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link.v-btn--main-link--right {
    &::after,
    &::before {
        left: 0;
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
        height: 160px;
        font-size: 3rem;
    }
}
@media (min-width: 1024px) {
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link {
        height: 200px;
        font-size: 3.6rem;
    }
    ::v-deep .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default.v-btn--main-link:hover {
        .icon-right-arrow-shadow {
            left: 15px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>